import * as Yup from 'yup';
import {
  INVALID_NAME_CHARACTERS_REGEX,
  EMAIL_REGEX,
  PHONE_REGEX,
  ZIP_CODE_REGEX,
} from 'commons/constants';

export const INITIAL_VALUES = {
  designer_profession: '',
  designer_website: '',
  designer_title: '',
  designer_first_name: '',
  designer_last_name: '',
  designer_company: '',
  designer_email: '',
  designer_mailing: '',
  designer_mailing_2: '',
  designer_city: '',
  designer_state: '',
  designer_zip: '',
  designer_phone: '',
  designer_organizations: '',
  designer_organizations_other: '',
  designer_interests: '',
  designer_interests_other: '',
  store_sq_footage: '',
  yearly_upholst_sale: '',
  newsletter_opt_in: false,
  tax_exempt: false,
  attachment_urls: [],
};

export const formSchema = Yup.object().shape({
  designer_profession: Yup.string().required('Required'),
  designer_first_name: Yup.string()
    .required('Required')
    .test(
      'test-fname',
      'No invalid characters allowed',
      value => !INVALID_NAME_CHARACTERS_REGEX.test(value)
    ),
  designer_last_name: Yup.string()
    .required('Required')
    .test(
      'test-lname',
      'No invalid characters allowed',
      value => !INVALID_NAME_CHARACTERS_REGEX.test(value)
    ),
  designer_email: Yup.string()
    .required('Required')
    .matches(EMAIL_REGEX, 'Invalid email'),
  designer_phone: Yup.string()
    .required('Required')
    .matches(PHONE_REGEX, 'Invalid phone'),
  designer_company: Yup.string().required('Required'),
  designer_website: Yup.string().required('Required'),
  attachment_urls: Yup.array().test(
    'attachments-required-for-tax-exempt',
    'Please upload supporting documentation for tax-exempt status',
    function validateAttachmentsForTaxExempt(value) {
      const taxExempt = this.parent && this.parent.tax_exempt;
      if (taxExempt) {
        return Array.isArray(value) && value.length > 0;
      }
      return true;
    }
  ),
  designer_mailing: Yup.string().required('Required'),
  designer_city: Yup.string().required('Required'),
  designer_state: Yup.string().required('Required'),
  designer_zip: Yup.string()
    .required('Required')
    .matches(ZIP_CODE_REGEX, 'Invalid zipcode'),
  designer_interests_other: Yup.string().required('Required'),
});

export const PROFESSIONS = [
  // 'Store Owner/Retailer', //commented for now
  'Interior Designer',
  'Design Firm/Organization',
  'Architect',
  'Hospitality**',
  'Specifier/Contract Buyer',
  'Other',
];

export const MEMBERSHIPS = [
  'ASID (American Society of Interior Designers or international affiliate)',
  'AIA (American Institute of Architects)',
  'CID (Certified Interior Decorators International)',
  'IIDA (International Interior Design Association)',
  'NCDIQ (National Council for Interior Design Qualification)',
  'AIDP (Association of Interior Design Professionals)',
  'Other, please explain how you are in the trade:',
];

export const INTERESTS = [
  'Upholstery',
  'Case Goods',
  'Other, please explain below',
];

export const MAX_TRADE_FILES = 2;
export const MAX_TRADE_TOTAL_SIZE = 20 * 1024 * 1024; // 20 MB total across all files
export const TRADE_FILE_ACCEPT = 'image/jpeg,image/png,application/pdf';
// Object format required by react-dropzone v12+
export const TRADE_FILE_ACCEPT_OBJECT = {
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'application/pdf': ['.pdf'],
};
